import { render, staticRenderFns } from "./FaqTab.vue?vue&type=template&id=28b64560&scoped=true&"
import script from "./FaqTab.vue?vue&type=script&lang=js&"
export * from "./FaqTab.vue?vue&type=script&lang=js&"
import style0 from "./FaqTab.vue?vue&type=style&index=0&id=28b64560&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b64560",
  null
  
)

export default component.exports